import React from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { Card, Row, Col, Steps } from "antd";
import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import "./Materials.css";
import DueDate from "../Common/DueDate";
import Stepinfo from "../Modals/Stepinfo";
import Resume from "./Resume/Resume";
import LinkedIn from "./LinkedIn/LinkedIn";
import CoverLetter from "./CoverLetter/CoverLetter";
import ProfSummary from "./ProfessionalSummary/ProfSummary";
import {
  selectMaterialsStepInfo,
  setStepNotifiedAsync,
  selectStepReflections,
} from "slices/dashboardSlice";
const { Step } = Steps;

class MaterialsBase extends React.Component {
  state = {
    current: this.props.current_step ? this.props.current_step : 0,
    collapsed: false, //menu collapse
    showInfo: null, //show/hide infobox
    setTarget: null, //show/hide duedate component
    curr_comp_target_date: {
      0: "",
      1: "",
      2: "",
      3: "",
      4: "",
    }, //date coming from Duedate.js
  };
  // checks if step is locked or not
  isLocked = (step) =>
    this.props.stepReflections[step]
      ? this.props.stepReflections[step].status === "LO"
      : false;

  //opens set date box (pink colored) if date in header is clicked
  setDateAgain = () => {
    // console.log('set!');
    this.setState({
      setTarget: true,
    });
  };

  //close button handling
  onCloseClick = () => {
    this.setState({
      setTarget: false,
    });
  };

  onCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
    this.props.toggle();
  };

  changeRoute = () => {
    this.props.history.push("/dashboard");
  };

  notifyStep = () => {
    console.log(
      "notify",
      this.state.current,
      this.props.stepInfo[this.state.current],
      !this.props.stepInfo[this.state.current].notified,
      this.props.impersonated
    );
    if (
      this.props.stepInfo[this.state.current] &&
      !this.props.stepInfo[this.state.current].notified &&
      this.props.impersonated
    ) {
      this.props.setStepNotifiedAsync(
        this.props.stepInfo[this.state.current].id,
        this.props.stepInfo[this.state.current].step
      );
    }
  };

  onDateSet = () => {
    // setTimeout(() => {
    console.log("DONE !");
    this.onCloseClick();
    // }, 6000);
  };

  newReleased = () =>
    this.props.stepInfo[this.state.current] &&
    !this.props.stepInfo[this.state.current].notified;

  showInfo = () =>
    this.state.showInfo === true ||
    (this.state.showInfo === null && this.newReleased());

  targetSet = () =>
    this.state.setTarget === true ||
    (this.state.setTarget === null &&
      !!this.props.stepInfo[this.state.current] &&
      this.props.stepInfo[this.state.current].complete_by === null &&
      this.props.stepInfo[this.state.current].status != 'DO');

  stepId = () =>
    !!this.props.stepInfo[this.state.current]
      ? this.props.stepInfo[this.state.current].id
      : -1;

  render() {
    // console.log('state', this.state)
    // {console.log('time', this.state.curr_comp_target_date[this.state.current])}
    const steps = [
      {
        title: "Professional Summary",
        content: <ProfSummary stepId={this.stepId()} />,
      },
      {
        title: "Resume",
        content: <Resume stepId={this.stepId()} />,
      },
      {
        title: "LinkedIn Profile",
        content: <LinkedIn stepId={this.stepId()} />,
      },
      {
        title: "Cover Letter",
        content: <CoverLetter stepId={this.stepId()} />,
      },
    ];

    return (
      // <div style={{ padding: "4% 0" }}>
      <div style={{ padding: "1% 0" }}>
        {/* <div className="collapse-btn" onClick={this.onCollapse}>
          {this.state.collapsed ? (
            <RightCircleFilled className="make-white" />
          ) : (
            <LeftCircleFilled className="make-white" />
          )}
        </div> */}

        <Card
          bordered={false}
          style={{
            margin: "20px !important",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "13px",
            textAlign: "left",
            marginRight: "6%",
            // marginLeft: "20px",
            marginLeft: `${this.props.collapsed ? "6%" : "20px"}`,
            padding: "0 2%",
          }}
        >
          <div>
            <Row style={{ padding: "4% 0% 3% 0%" }}>
              <Col
                span={18}
                style={{
                  font: "normal normal 300 30px/12px AvenirBook",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {
                  console.log('sss this.state.current', this.state.current, steps)
                }
                {steps[this.state.current].title}&nbsp;
                {/* <span
                  className={`just-released ${
                    this.newReleased() ? "" : "hidden"
                  }`}
                >
                  NEW
                </span> */}
                {this.props.stepInfo[this.state.current] && (
                  // this.props.stepInfo[this.state.current].complete_by !== null &&
                  <span
                    style={{
                      fontSize: "16px",
                      cursor: "pointer",
                      position: "relative",
                      marginLeft: "20px",
                      whiteSpace: "nowrap",
                    }}
                    onClick={this.setDateAgain}
                  >
                    <img
                      src="https://django-woken-static.s3.amazonaws.com/static/media/calendaricon.c713d4db.svg"
                      style={{ position: "relative", top: "-3px" }}
                    ></img>
                    &nbsp;&nbsp;
                    {this.props.stepInfo[this.state.current].complete_by
                      ? "Due date"
                      : "Set Due Date"}
                    &nbsp;
                    {this.props.stepInfo[this.state.current] &&
                      this.props.stepInfo[this.state.current].complete_by &&
                      Moment(
                        this.props.stepInfo[this.state.current].complete_by
                      ).format("MM-DD-YYYY")}
                  </span>
                )}
              </Col>
              <Col
                span={6}
                style={{
                  textAlign: "right",
                  fontSize: "26px",
                  marginTop: "-20px",
                }}
              >
                <a
                  href="mailto: team@iamwoken.com?subject=WOKEN client inquiry "
                  target="_blank"
                  style={{
                    paddingRight:"10px"
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
  <g id="mail_2_" data-name="mail (2)" transform="translate(-0.001)">
    <g id="Group_2502" data-name="Group 2502" transform="translate(0.001)">
      <path id="Path_1376" data-name="Path 1376" d="M14,0A14,14,0,1,0,28,14,14,14,0,0,0,14,0Zm0,4.917,8.285,5.166H5.716Zm8.388,13.416h0a1.5,1.5,0,0,1-1.5,1.5H7.114a1.5,1.5,0,0,1-1.5-1.5V10.412a1.492,1.492,0,0,1,.024-.257l7.915,4.936.03.016.032.017a.831.831,0,0,0,.172.067l.018,0a.854.854,0,0,0,.2.025h0a.839.839,0,0,0,.2-.025l.018,0a.839.839,0,0,0,.172-.067l.032-.017.03-.016,7.915-4.936a1.49,1.49,0,0,1,.024.257v7.921Z" transform="translate(-0.001)" fill="#199094"/>
    </g>
  </g>
</svg>
                </a>
                <span
                  onClick={() =>
                    this.setState({
                      showInfo: true,
                    })
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" style={{marginTop: "5px"}}>
  <path id="question" d="M14,0A14,14,0,1,0,28,14,14.015,14.015,0,0,0,14,0Zm0,22.167A1.167,1.167,0,1,1,15.167,21,1.167,1.167,0,0,1,14,22.167Zm1.847-7.418a1.172,1.172,0,0,0-.68,1.061v.524a1.167,1.167,0,1,1-2.333,0V15.81a3.515,3.515,0,0,1,2.036-3.18,3.813,3.813,0,0,0,2.047-2.713,2.917,2.917,0,1,0-5.833,0,1.167,1.167,0,1,1-2.333,0,5.25,5.25,0,1,1,10.5,0,6.079,6.079,0,0,1-3.4,4.832Zm0,0" fill="#199094"/>
</svg>
                </span>
              </Col>
            </Row>
            <p
              style={{
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #F0F0F0",
              }}
            ></p>
          </div>

          {this.showInfo() ? (
            <Stepinfo
              stepname={steps[this.state.current].title}
              closeInfo={() => {
                this.notifyStep();
                this.setState({
                  showInfo: false,
                });
              }}
            />
          ) : this.targetSet() ? (
            <div>
              <DueDate
                stepName={steps[this.state.current].title}
                stepKey={this.props.stepInfo[this.state.current].step}
                onDateSet={this.onDateSet}
                onCloseClick={this.onCloseClick}
                stepId={this.props.stepInfo[this.state.current].id}
                targetDate={
                  this.props.stepInfo[this.state.current].complete_by !== null
                    ? Moment(
                        this.props.stepInfo[this.state.current].complete_by
                      )
                    : null
                }
              />
              <div style={{ opacity: "1", pointerEvents: "none" }}>
                <Steps
                  current={this.state.current}
                  onChange={(current) => this.setState({ current: current })}
                  className="networking-nav"
                >
                  {/* {steps.map(item => (
                                <Step key={item.title} title={item.title.toUpperCase()} onClick={()=>{<Redirect to='/dashboard'/>}}/>
                            ))} */}
                  <Step
                    key="1"
                    title={steps[0].title}
                    disabled={this.isLocked("PS") ? true : false}
                    onClick={() => {
                      if (!this.isLocked("PS"))
                        this.props.history.push(
                          "/materials/professional-summary"
                        );
                    }}
                    status={this.state.current === 0 ? "process" : "wait"}
                  />
                  <Step
                    key="2"
                    title={steps[1].title}
                    disabled={this.isLocked("RE") ? true : false}
                    onClick={() => {
                      if (!this.isLocked("RE"))
                        this.props.history.push("/materials/resume");
                    }}
                    status={this.state.current === 1 ? "process" : "wait"}
                  />
                  <Step
                    key="3"
                    title={steps[2].title}
                    disabled={this.isLocked("LK") ? true : false}
                    onClick={() => {
                      if (!this.isLocked("LK"))
                        this.props.history.push("/materials/linkedin");
                    }}
                    status={this.state.current === 2 ? "process" : "wait"}
                  />
                  <Step
                    key="4"
                    title={steps[3].title}
                    disabled={this.isLocked("CL") ? true : false}
                    onClick={() => {
                      if (!this.isLocked("CL"))
                        this.props.history.push("/materials/cover-letter");
                    }}
                    status={this.state.current === 3 ? "process" : "wait"}
                  />
                </Steps>

                {steps[this.state.current].content}
              </div>
            </div>
          ) : (
            <div>
              <Steps
                current={this.state.current}
                onChange={(current) => this.setState({ current: current })}
                className="networking-nav"
              >
                {/* {steps.map(item => (
                                <Step key={item.title} title={item.title.toUpperCase()} />
                            ))} */}
                <Step
                  key="1"
                  title={steps[0].title}
                  disabled={this.isLocked("PS") ? true : false}
                  onClick={() => {
                    if (!this.isLocked("PS"))
                      this.props.history.push(
                        "/materials/professional-summary"
                      );
                  }}
                  status={this.state.current === 0 ? "process" : "wait"}
                />
                <Step
                  key="2"
                  title={steps[1].title}
                  disabled={this.isLocked("RE") ? true : false}
                  onClick={() => {
                    if (!this.isLocked("RE"))
                      this.props.history.push("/materials/resume");
                  }}
                  status={this.state.current === 1 ? "process" : "wait"}
                />
                <Step
                  key="3"
                  title={steps[2].title}
                  disabled={this.isLocked("LK") ? true : false}
                  onClick={() => {
                    if (!this.isLocked("LK"))
                      this.props.history.push("/materials/linkedin");
                  }}
                  status={this.state.current === 2 ? "process" : "wait"}
                />
                <Step
                  key="4"
                  title={steps[3].title}
                  disabled={this.isLocked("CL") ? true : false}
                  onClick={() => {
                    if (!this.isLocked("CL"))
                      this.props.history.push("/materials/cover-letter");
                  }}
                  status={this.state.current === 3 ? "process" : "wait"}
                />
              </Steps>
              {steps[this.state.current].content}
            </div>
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  stepInfo: selectMaterialsStepInfo(state),
  stepReflections: selectStepReflections(state),
});

const mapDispatchToProps = () => ({
  setStepNotifiedAsync,
});

export default connect(mapStateToProps, mapDispatchToProps())(MaterialsBase);
